module.exports = __webpack_public_path__ + "static/media/file.9abb1650.svg";